import { Tooltip as ArkTooltip } from '@ark-ui/react/tooltip'
import { cn } from '~/utils/cn'
import { content as contentStyles } from './tooltip.styles'
import { Button } from '../button'

export type TooltipContentProps = Omit<ArkTooltip.ContentProps, 'className'> & {
  showCloseButton?: boolean
  onClickClose?: () => void
}

export function TooltipContent({
  children,
  showCloseButton = false,
  onClickClose,
  ...props
}: TooltipContentProps) {
  return (
    <ArkTooltip.Positioner>
      <ArkTooltip.Content
        data-testid="tooltip-content"
        className={cn(contentStyles())}
        {...props}
      >
        <ArkTooltip.Arrow
          style={
            {
              '--arrow-size': 'var(--sizing-micro)',
              '--arrow-background': 'var(--color-fill-neutral-default)',
            } as Record<string, string>
          }
        >
          <ArkTooltip.ArrowTip className="border-t border-l" />
        </ArkTooltip.Arrow>
        <div
          className={cn(
            'flex w-fit items-center gap-[var(--spacing-stack-twopulse)]'
          )}
        >
          <div className={cn('line-clamp-4')}>{children}</div>
          {showCloseButton && (
            <ArkTooltip.Context>
              {tooltip => (
                <Button.Root
                  onClick={onClickClose ?? (() => tooltip.setOpen(false))}
                  variant="neutral-tertiary"
                  size="ml"
                  data-testid="tooltip-close-button"
                >
                  <Button.Icon symbol="rdicon-dismiss" />
                </Button.Root>
              )}
            </ArkTooltip.Context>
          )}
        </div>
      </ArkTooltip.Content>
    </ArkTooltip.Positioner>
  )
}

TooltipContent.displayName = 'TooltipContent'
